import React from 'react';

import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';

const SortDropdown = ({ onChange, options, value, placeholder, className }) => {
    return (
        <Dropdown
            options={options}
            onChange={onChange}
            value={value}
            placeholder={placeholder}
            className={className}
        />
    )
}

export default SortDropdown
